import React from 'react'
import { Outlet } from 'react-router-dom'

interface SystemLayoutProps {
  children: React.ReactNode
}

const SystemLayout = ({ children }: SystemLayoutProps) => {
  return (
    <article className="system-layout">
      {children}
      <Outlet />
    </article>
  )
}

export default SystemLayout
